import React from "react";
import { colors2 } from "oolib";
import { UI_CAPTION_DF } from "oolib/dist/v2/components/Typo2";
import { ArrowUp, ArrowDown } from "@phosphor-icons/react";
import TablePill from "../TablePill";

/**
 * A change, read as a word or a percent with its direction: an arrow up or
 * down before the text, in a colour and weight the row decides (red
 * semibold for a worsening, green semibold for an improvement, plain for
 * no change). `badge` swaps the whole cell for a small pill — "New" for a
 * value that has no earlier period to change from.
 *
 * Per row (dynamicPropsCallback): `text`, `arrow` ("up" | "down" | null),
 * `color`, `semibold`, `badge`, `badgeBg`, `badgeColor`, `hint`.
 */
const TableChange = ({ value, text, arrow, color, semibold = false, badge, badgeBg, badgeColor, hint }) => {
  if (badge) return <TablePill value={badge} bg={badgeBg} color={badgeColor} hint={hint} />;
  const display = text ?? value;
  if (display === undefined || display === null || display === "") return null;
  const Arrow = arrow === "up" ? ArrowUp : arrow === "down" ? ArrowDown : null;
  return (
    <span
      title={hint || undefined}
      style={{ display: "inline-flex", alignItems: "center", gap: "0.2rem", minWidth: 0, color: color || colors2.grey80, whiteSpace: "nowrap" }}
    >
      {Arrow && <Arrow size={12} weight="bold" />}
      <UI_CAPTION_DF style={{ color: "inherit", fontWeight: semibold ? 600 : 400, fontVariantNumeric: "tabular-nums" }}>{display}</UI_CAPTION_DF>
    </span>
  );
};

export default TableChange;
